import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import EditorialHeroSection from '../components/sections/EditorialHeroSection'
import WelcomeSection from '../components/sections/WelcomeSection'
import CoverStorySection from '../components/sections/CoverStorySection'
import EditorialSearchSection from '../components/sections/EditorialSearchSection'
import EditorialResultsSection from '../components/sections/EditorialResultsSection'
import EditorialSignupSection from '../components/sections/EditorialSignupSection'

const EditorialPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('ALL')

  useEffect(() => {
    // Check for category query parameter on page load
    const urlParams = new URLSearchParams(window.location.search)
    const categoryParam = urlParams.get('category')
    if (categoryParam) {
      setSelectedCategory(categoryParam)
      // Scroll to the search section after a short delay to ensure rendering
      setTimeout(() => {
        const element = document.getElementById('editorial-search-section')
        element?.scrollIntoView({ behavior: 'smooth' })
      }, 100)
    }
  }, [])

  const handleSearch = (query: string) => {
    setSearchQuery(query)
  }

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category)
    // Update URL without causing a page reload
    const url = new URL(window.location.href)
    if (category === 'ALL') {
      url.searchParams.delete('category')
    } else {
      url.searchParams.set('category', category)
    }
    window.history.replaceState({}, '', url.toString())
  }

  return (
    <>
      <Helmet>
        <title>Editorial - Fashion Insights & Luxury Lifestyle</title>
        <meta name="description" content="Discover the latest in luxury fashion, style guides, brand stories, and lifestyle insights from FGA Prestige. Your ultimate source for sophisticated fashion editorial content." />
        <meta property="og:title" content="Editorial - FGA Prestige" />
        <meta property="og:description" content="Discover the latest in luxury fashion, style guides, and lifestyle insights from FGA Prestige." />
        <meta property="og:url" content="https://fgaprestige.com/editorial" />
        <meta property="og:image" content="/og-editorial.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Editorial" />
      </Helmet>

      <main className="min-h-screen">
        {/* Hero Section - Editorial specific with background image */}
        <EditorialHeroSection />

        <div style={{ backgroundColor: '#F7F8FA', padding: '64px 0' }}>
          <div className="max-w-6xl mx-auto px-6 text-center">
            <p style={{ fontFamily: 'Cardo, serif' }}>At FGA Prestige, we stay ahead of the curve. Drawing on our trusted global network, our curated articles showcase the latest in luxury living—from bespoke travel and fine dining to art, wellness, and beyond. Stay informed and inspired with what’s new, noteworthy, and tailored for you.</p>
            <div style={{ marginTop: '16px' }}>
              <button
                onClick={() => {
                  const element = document.getElementById('editorial-signup');
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}
                style={{
                  backgroundColor: '#000000',
                  color: '#FFFFFF',
                  padding: '12px 24px',
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: '400',
                  cursor: 'pointer'
                }}
              >
                Sign up to our Editorial
              </button>
            </div>
          </div>
        </div>

        {/* Cover Story Section */}
        <CoverStorySection />

        {/* Editorial Search Section */}
        <EditorialSearchSection
          onSearch={handleSearch}
          onCategoryChange={handleCategoryChange}
          selectedCategory={selectedCategory}
        />

        {/* Editorial Results Section */}
        <EditorialResultsSection
          searchQuery={searchQuery}
          selectedCategory={selectedCategory}
        />

        {/* Editorial Signup Section */}
        <EditorialSignupSection />


      </main>
    </>
  )
}

export default EditorialPage